const mutations = {
    add(state, object) {
        state.itens.push(object);
    },
    setList(state, list) {
        state.itens = list;
    },
    setListAfterSales(state, list) {
        state.after_sales = list;
    },
    setListManagers(state, list) {
        state.managers = list;
    },
    setListSalesmans(state, list) {
        console.log(list);
        state.salesmans = list;
    },
    setListSupervisors(state, list) {
        state.supervisors = list;
    },
    setObject(state, object) {
        state.item = object;
        state.item.password = '';
        state.item.functionalities = [];
    },
    delObject(state, object) {
        state.itens.splice(state.itens.indexOf(object), 1);
    }
};

export default mutations;